const Form = () => import("~/components/Views/Prova/RealizarProva/Form");
const List = () => import("~/components/Views/Prova/RealizarProva/List");

import auth from "~/middleware/auth";
import perfilVerify from "~/middleware/perfilVerify";

const breadcrumb = [
  { name: "Integrado", link: "http://on.grupointegrado.br/" },
  { name: "Prova", link: "" },
  { name: "Gerenciamento", link: "" }
];

export const realizarProva = [
  {
    path: "gerenciamento/realizar-prova/:aplicacaoProvaId",
    component: Form,
    name: "Realizar Prova",
    meta: {
      middleware: [auth, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "gerenciamento/realizar-prova/:aplicacaoProvaId/:alunoId",
    component: Form,
    name: "Revisão de Prova",
    meta: {
      middleware: [auth, perfilVerify],
      breadcrumb
    }
  }
];



// WEBPACK FOOTER //
// ./src/routes/prova/gerenciamento/realizarProva.js